<template>
  <app-modalData :init = "metaData"  @f="f($event)"  v-if="metaData">


<div slot="icons">

  <v-tooltip  v-if="da" allow-overflow open-delay="800"
     left max-width="250">
      <v-icon slot="activator" v-bind:class="{actives: fastUpdating.auto}" v-if="!updating.auto" @click="fastAutoStarter()" >mdi-flash</v-icon>
      <span> Авто  обновление страниц на которые подписались прямо сейчас</span>
   </v-tooltip>



  <v-tooltip v-if='!fastUpdating.auto'  allow-overflow open-delay="800"
     left max-width="250">
  <v-icon slot="activator" v-bind:class="{actives: updating.auto}" @click="autoUpdaterStarter()">mdi-autorenew</v-icon>
   <span> Периодическое обновление выбранных ({{this.pages.checkList.length}}) страниц </span>
  </v-tooltip>

  <v-tooltip v-if='!fastUpdating.auto'  allow-overflow open-delay="800"
     left max-width="250">
  <v-icon slot="activator" @click="updaterMembers(pages.checkList[updating.currentPage])" >mdi-update</v-icon>
   <span> Обновить список выбранных  ({{this.pages.checkList.length}}) страниц </span>
 </v-tooltip>



  <v-tooltip  allow-overflow open-delay="800"
     left max-width="250">
  <v-icon slot="activator" medium @click="closeUpdater()">mdi-close</v-icon>
<span>Закрыть обновления страниц</span>
 </v-tooltip>



</div>
 
<span slot="status">
<span v-if="updating.inProccess"  style="font-size:1.3em; margin:5px;color:#727272">   Обновление  {{updating.updatingPercent.toFixed() }} %  </span>
<span v-if="!updating.inProccess &&  updating.auto"  style="font-size:1.3em; margin:5px;color:#727272">   Обновление через  {{autoUpdater}}    </span>
</span>


 <div slot="starter"   class="text-xs-center" v-if="starter">
   <p style="padding:15px">
       Данная возможность позволяет получить список новых подписчиков
       и тех кто отписался в
       выбранных вами сообществаx
   </p>

 <v-btn  @click="starter = false;updaterMembers(pages.checkList[updating.currentPage])" color="primary"> Обновить выбранные страницы</v-btn>
 </div>
 <div slot="operations">
   <v-dialog  v-model="autoparams" width="500">
 <v-card>
 <v-card-text>

   <p style="color:#757575;font-size:1.3em"> Через какое время обновлять процесс  ?</p>
     <v-layout row>



       <v-flex class="px-3">
         <v-subheader>Часы</v-subheader>
        <v-slider
        max="23"
        v-model="updating.intervalSet.hours"
        color="primary"
        thumb-label="always"
        ></v-slider>
        </v-flex>

        <v-flex class="px-3">
          <v-subheader>Минуты</v-subheader>
         <v-slider
         v-model="updating.intervalSet.min"
         max="59"
         color="primary"
         thumb-label="always"
         ></v-slider>
         </v-flex>


       <v-flex class="px-3">
         <v-subheader>Секунды</v-subheader>
         <v-slider
         v-model="updating.intervalSet.sec"
         max="59"
         color="primary"
         thumb-label="always"
         ></v-slider>
         </v-flex>




     </v-layout>



<v-checkbox
@click="skListGet()"
v-model="scripts.selectSk"
label="Экспортировать данные цикла в скрипт? "
/>


<div v-if="scripts.selectSk">

<div v-for="item of scripts.list">
<v-checkbox color="#4A76A8" v-model="scripts.selected"  v-bind ='[{label:item.name},{value:item.path}]'     />
</div>


</div>






 </v-card-text>
 <v-card-actions>
 <v-btn  @click="autoUpdaterStart()" block color="primary">Сохранить </v-btn>
</v-card-actions>
 </v-card>
   </v-dialog>

 </div>
  </app-modalData>

</template>




<script>
import axios from 'axios'
export default {
props: ['modals', 'pages'],
 data: function(){
  return {
da:false,
    fastUpdating: {
      sensor: 2,
      firstState: {},
      auto: false,
      inProccess : false,
      interval: 7,

    },


    starter: true,
    autoparams: false,

    scripts:{
    list : [],
    selectSk : false,
    selected: [],
    },



    modalData:{
     sb: {
       snackbar: false,
       color: 'success',
       text: ''
     },
     f: "",
     selectedItem: "followers",
       header:{
         text:"",
          icon:"mdi-database",
         icons:[
         ]
       },
     bar: {
         items:[
           {
              itemName: 'followers',
              text:'Подписчики',
              f: null,

           },
           {
              itemName: 'followers_out',
              text:'Отписки',
              f: null,

           },
           {
              itemName: 'friends',
              text:'Друзья',
              f: null,

           },
           {
              itemName: 'friends_out',
              text:'Удалились из друзей',
              f: null,

           },
           {
              itemName: 'friends_out_to_followers',
              text:'Удалили из друзей',
              f: null,

           },

         ],
         status: ""
       },
     content:{
       type:'pages',
         items:{

             followers:{
               foundData: {},
               meneger:{}
             },


             followers_out:{
               foundData: {},
               meneger:{}
             },
             friends:{
               foundData: {},
               meneger:{}
             },


             friends_out:{
               foundData: {},
               meneger:{}
             },
             friends_out_to_followers:{
               foundData: {},
               meneger:{}
             },
         },
       },


     operations:{

     }

    },

    updating: {
      intervalSet: {
        sec: 59,
        min: 9,
        hours: 0,
      },
      inProccess : false,
      interval: 7,
      timer: 35,
      auto: false,
      currentPage: 0,
      updatingPercent: 0,
    },


  }
},


methods: {

  f(fName){
  eval('this.'+fName+'()')
  },




 skListGet(){
       axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/scripts/get_list.php', {
            method: 'POST',
            data: {
              data: null
            }
          })
          .then( response => {
           this.scripts.list =  response.data
          })
 },






fastAutoStarter(){

  if(this.fastUpdating.auto){
     this.fastUpdating.auto = false
     this.pages.checker.followerInContentMenegment.items.autoExport.active = false
  } else {
  this.fastUpdating.auto = true
  this.pages.checker.followerInContentMenegment.items.autoExport.active = true
}
},


  closeUpdater(){
    this.pages.modals.checkPages = false
    this.pages.selector = false
    this.updating.auto = false
    this.foundDataClear()
    this.pages.checkList = []

  },

  updaterMembers(pgId){
this.starter = false
  //  console.log(this.pages.checkList)
  //  this.pages.checkList
   this.updating.inProccess = true
          axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/pages/pages_check.php', {
               method: 'POST',
               data: {
                 id: pgId,
                 useOnlyMine: this.modals.useOnlyMine,
               }
             }).then(response => {




  // offset current group
      if(this.updating.currentPage <= this.pages.checkList.length){
       this.updaterMembers(this.pages.checkList[++this.updating.currentPage])
       if(this.updating.currentPage <= this.pages.checkList.length){this.updating.updatingPercent = this.updating.currentPage / this.pages.checkList.length  * 100}

      } else {
         this.updating.currentPage  = 0
         this.updating.inProccess = false
         this.updating.updatingPercent = 0

       }

       if(response.data.followers_new  !== 'undefined' && response.data.followers_new !== null) {
         this.pages.checker.followers.foundData.foundIds = this.pages.checker.followers.foundData.foundIds.concat(response.data.followers_new)
         // авто экспорт в задания
         if(this.pages.checker.followerInContentMenegment.items.autoExport.active){
           axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/tasks/add_resourcess.php', {
                method: 'POST',
                data: {
                useSourceInfo: 'no data',
                sorceType: 'pages',
                sourceDesc: 'Новый подписчик страницы',
                source: pgId,
                taskIds: this.pages.checker.followerInContentMenegment.autoExport.tasksList,
                data: response.data.followers_new
                }
              }).then(response => {
              })
         }
       }


       if(response.data.followers_new_out  !== 'undefined' && response.data.followers_new_out !== null) {this.pages.checker.followers_out.foundData.foundIds = this.pages.checker.followers_out.foundData.foundIds.concat(response.data.followers_new_out)  }
       if(response.data.friends_new  !== 'undefined' && response.data.friends_new !== null) {this.pages.checker.friends.foundData.foundIds = this.pages.checker.friends.foundData.foundIds.concat(response.data.friends_new)  }
       if(response.data.friends_new_out  !== 'undefined' && response.data.friends_new_out !== null) {this.pages.checker.friends_out.foundData.foundIds = this.pages.checker.friends_out.foundData.foundIds.concat(response.data.friends_new_out)  }
       if(response.data.friends_new_outs_to_followers  !== 'undefined' && response.data.friends_new_outs_to_followers !== null) {this.pages.checker.friends_out_to_followers.foundData.foundIds = this.pages.checker.friends_out_to_followers.foundData.foundIds.concat(response.data.friends_new_outs_to_followers)  }




       if(this.scripts.selectSk){
             if(this.scripts.selected.length > 0){
                if(response.config.data !== '{}'){
                //  console.log(JSON.parse(response.config.data))
                //  console.log(response.data)

                  let abonent  = JSON.parse(response.config.data)
                  let payload  = response.data

               this.scripts.selected.forEach((item,i,arr)=>{
                              axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/scripts/scripts/'+item, {
                                   method: 'POST',
                                   data: {
                                     path: item,
                                     abonent: abonent,
                                     payload: payload,
                                   }
                                 })
                                 .then( response => {
                                   this.skList  = response.data
                                   //this.addScriptModal  =  false
                                   //console.log(response.data)
                                 })

               })



                }
             }
         }



             })


  },
  reUpdater(){
     this.updaterMembers(this.pages.checkList[this.updating.currentPage])
  },


 autoUpdaterStarter(){
   if(this.updating.auto){
     this.autoparams = false
     this.autoUpdaterOn()
   } else { this.autoparams = true }

 },
 autoUpdaterStart(){
   this.updating.interval = this.updating.intervalSet.sec + (this.updating.intervalSet.min * 60 ) + (this.updating.intervalSet.hours * 60 *60)
   this.autoparams = false
   this.autoUpdaterOn()
 },

  autoUpdaterOn(){

    if(this.updating.auto){
      this.updating.auto = false
      this.updating.timer == 'off'

      this.pages.checker.followerInContentMenegment.items.autoExport.active = false
      this.pages.checker.followerOutContentMenegment.items.autoExport.active = false
      this.pages.checker.friendsInContentMenegment.items.autoExport.active = false
      this.pages.checker.friendsOutContentMenegment.items.autoExport.active = false
      this.pages.checker.friendsOutToFollowersContentMenegment.items.autoExport.active = false
    } else {


      this.pages.checker.followerInContentMenegment.items.autoExport.active = true
      this.pages.checker.followerOutContentMenegment.items.autoExport.active = true
      this.pages.checker.friendsInContentMenegment.items.autoExport.active = true
      this.pages.checker.friendsOutContentMenegment.items.autoExport.active = true
      this.pages.checker.friendsOutToFollowersContentMenegment.items.autoExport.active = true

      this.updating.auto = true
      this.updating.timer = 'on'
    }
  },


foundDataClear(){
  this.pages.checker.followers.foundData.selector = false
  this.pages.checker.followers.foundData.foundIds = []
  this.pages.checker.followers.foundData.displayIds = []
  this.pages.checker.followers.foundData.selectedIds = []
  this.pages.checker.followers.foundData.offset = 0

  this.pages.checker.followers_out.foundData.selector = false
  this.pages.checker.followers_out.foundData.foundIds = []
  this.pages.checker.followers_out.foundData.displayIds = []
  this.pages.checker.followers_out.foundData.selectedIds = []
  this.pages.checker.followers_out.foundData.offset = 0

  this.pages.checker.friends.foundData.selector = false
  this.pages.checker.friends.foundData.foundIds = []
  this.pages.checker.friends.foundData.displayIds = []
  this.pages.checker.friends.foundData.selectedIds = []
  this.pages.checker.friends.foundData.offset = 0


  this.pages.checker.friends_out.foundData.selector = false
  this.pages.checker.friends_out.foundData.foundIds = []
  this.pages.checker.friends_out.foundData.displayIds = []
  this.pages.checker.friends_out.foundData.selectedIds = []
  this.pages.checker.friends_out.foundData.offset = 0

  this.pages.checker.friends_out_to_followers.foundData.selector = false
  this.pages.checker.friends_out_to_followers.foundData.foundIds = []
  this.pages.checker.friends_out_to_followers.foundData.displayIds = []
  this.pages.checker.friends_out_to_followers.foundData.selectedIds = []
  this.pages.checker.friends_out_to_followers.foundData.offset = 0
},
},

computed: {







  metaData(){
    if(this.pages.modals.checkPages){


      this.starter = true
      this.modalData.header.text = 'Обновления страниц'



      this.modalData.content.items.followers.foundData = this.pages.checker.followers.foundData
      this.modalData.content.items.followers.meneger =  this.pages.checker.followerInContentMenegment

      this.modalData.content.items.followers_out.foundData = this.pages.checker.followers_out.foundData
      this.modalData.content.items.followers_out.meneger = this.pages.checker.followerOutContentMenegment

      this.modalData.content.items.friends.foundData = this.pages.checker.friends.foundData
      this.modalData.content.items.friends.meneger = this.pages.checker.friendsInContentMenegment

      this.modalData.content.items.friends_out.foundData = this.pages.checker.friends_out.foundData
      this.modalData.content.items.friends_out.meneger = this.pages.checker.friendsOutContentMenegment

      this.modalData.content.items.friends_out_to_followers.foundData = this.pages.checker.friends_out_to_followers.foundData
      this.modalData.content.items.friends_out_to_followers.meneger = this.pages.checker.friendsOutToFollowersContentMenegment

      return this.modalData
    } else return false
    },






  autoUpdater(){

     if(this.updating.timer > 0 ) {
       if(this.updating.auto){

//!this.updating.inProccess
   setTimeout( ()=>{
        if(!this.updating.inProccess){
          --this.updating.timer
        } else {
          --this.updating.timer
          ++this.updating.timer
        }
       }, 1000)
    return this.updating.timer
  }  else {
     this.updating.timer = this.updating.interval
     return this.updating.timer
  }
} else if (this.updating.timer == 'off') {
  this.updating.timer = this.updating.interval
  return false
} else if (this.updating.timer == 'on') {
  this.updating.timer = this.updating.interval
  return this.autoUpdater
}  else  {
     this.reUpdater()
     this.updating.timer = this.updating.interval
     return  this.autoUpdater
  }
  },
},


}
</script>

<style  >

</style>
